/**
 * Decode HTML entities in a string
 * @param text - Text with HTML entities
 * @returns Decoded text
 */
export const decodeHtmlEntities = (text: string): string => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
};

/**
 * Format date as localized string
 * @param date - Date object
 * @returns Formatted date string
 */
export const formatDate = (date: Date = new Date()): string => {
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};
